import { CookieList, IUser } from '@beneficity/authentication/types';

export interface AuthState {
  origin: string;
  isAuthenticated: boolean;
  accessToken?: string;
  attributes?: Record<string, unknown>;
  user?: IUser;
  error?: any | null;
  oamRefreshAttempted: boolean;
  logoutAttempted?: boolean;
  cookies: CookieList;
  searchType?: string;
}

export const initialState: AuthState = {
  origin: '',
  isAuthenticated: false,
  accessToken: undefined,
  user: undefined,
  error: undefined,
  oamRefreshAttempted: false,
  logoutAttempted: false,
  cookies: undefined,
  searchType: undefined,
};
